import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmitQuoteModel } from 'src/app/core/model/submit-quote-model';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { ModalConfig } from '../../../core/model/modal.config-model';

@Component({
    selector: 'app-unpublished-batch-modal',
    templateUrl: './unpublished-batch-modal.component.html',
    styleUrls: ['./unpublished-batch-modal.component.scss'],
    standalone: false
})
export class UnpublishedBatchModalComponent implements OnInit {
  @Input() code: any;
  constructor(private toastService: ToastService,private router: Router,public activeModal: NgbActiveModal,private inventoryManagementService:InventoryManagementService) { }

  ngOnInit(): void {
  }
  unPublish(){
    this.inventoryManagementService.unpublishBatch(this.code,"archive").subscribe(
      data => {
        if(data.status === "Product is archived successfully"){
          this.toastService.showAndNavigate(data.status).subscribe(_=>this.router.navigate(['inventory/inventorymanagement']));
        }
      }
    );
    this.activeModal.close('unPublish')
  }
}




  
